export default __webpack_public_path__ + "static/media/braintree.e78ba81d.svg";